// TES-1290 — which prefill of "Läkarens kommentar till behandlingsbeslutet"
// a surface shows. The prefill itself is the contract's
// (treatment-comment.ts), so every surface words a decision kind the same.
//
// Pure on purpose: no React, no path aliases. The unit tests in
// `apps/admin/test` run it with plain `node --test`.
import type { TreatmentCommentOutcome } from "@care-by-ella/contracts";

interface OrderLike {
  medication?: string | null;
  dose?: string | null;
  frequency?: string | null;
}

const norm = (v: string | null | undefined) =>
  (v ?? "").trim().toLowerCase().replace(/\s+/g, " ");

/**
 * The monthly review: a dose change when the order on screen differs from
 * the one in force, otherwise the plan continues. A cycle with no structured
 * order to compare with (before TES-636) counts as continuing.
 */
export function monthlyCommentOutcome(
  current: OrderLike | null,
  next: OrderLike,
): Extract<TreatmentCommentOutcome, "renewed" | "dose_changed"> {
  if (!current || !norm(current.dose)) return "renewed";
  const changed =
    norm(current.medication) !== norm(next.medication) ||
    norm(current.dose) !== norm(next.dose) ||
    norm(current.frequency) !== norm(next.frequency);
  return changed ? "dose_changed" : "renewed";
}

/**
 * The first decision. Only an approval carries the comment (TES-1311: never
 * on a komplettering or "Kan inte gå vidare"); after kompletteringar it says
 * whether the planned treatment was kept or changed.
 */
export function decisionCommentOutcome(
  outcome: string | null,
  planChoice: "kept" | "changed" | null,
): Extract<TreatmentCommentOutcome, "approve" | "kept" | "changed"> | null {
  if (outcome !== "approve") return null;
  return planChoice ?? "approve";
}
